// Persian interface copy only; source passages and user messages stay verbatim.
export const persianTranslations = {
  "Gelişmiş arama": "جستجوی پیشرفته",
  "Sohbet soruları, konu başlıkları ve kitap künyelerinde arayın. Tam transkript veya kitap gövdesi araması ve doğrulanmış AI cevabı henüz sunulmuyor.": "در پرسش‌های گفتگو، موضوع‌ها و مشخصات کتاب‌ها جستجو کنید. جستجوی متن کامل و پاسخ تأییدشده هوش مصنوعی هنوز ارائه نمی‌شود.",
  "Aranacak kelimeler": "واژه‌های جستجو",
  "Soru, konu veya eser…": "پرسش، موضوع یا اثر…",
  "Kaynak türü": "نوع منبع",
  "Sohbetler ve Kütüphane": "گفتگوها و کتابخانه",
  "Konu": "موضوع",
  "Tüm konular": "همه موضوع‌ها",
  "Yalnız hazır metne bağlı kayıtlar": "فقط رکوردهای دارای متن آماده",
  "Sonuç yok. Kapsamı veya kelimeleri değiştirin.": "نتیجه‌ای یافت نشد. محدوده یا واژه‌ها را تغییر دهید.",
  "Kayıt bulundu": "رکورد یافت شد",
  "İlk 30 kayıt gösteriliyor. Aramayı daraltın.": "۳۰ رکورد نخست نمایش داده می‌شود. جستجو را محدود کنید.",
  "Katalog ve yayın bilgisi": "اطلاعات فهرست و انتشار",
  "Hazır metne bağlı kayıt": "رکورد دارای متن آماده",
  "Yönetimden duyurular, güncellemeler ve bilgilendirmeler.": "اطلاعیه‌ها، به‌روزرسانی‌ها و اطلاعات مدیریت.",
  "Henüz yayımlanmış duyuru yok.": "هنوز اطلاعیه‌ای منتشر نشده است.",
  "Yeni duyurular burada yer alacak.": "اطلاعیه‌های تازه در اینجا قرار می‌گیرند.",
  "Bugün hangi konuyu araştıralım?": "امروز درباره چه موضوعی تحقیق کنیم؟",
  "Mahmut Efendim’in sohbetleri ve kütüphane kaynakları üzerine sorun.": "درباره گفتگوهای محمود افندیم و منابع کتابخانه بپرسید.",
  "Yeni sohbet oluştur": "ایجاد گفتگوی تازه",
  "Yayın başladığında burada izleyebilirsiniz.": "با آغاز پخش می‌توانید آن را اینجا تماشا کنید.",
  "Şu anda canlı yayın yok": "اکنون پخش زنده‌ای وجود ندارد",
  "Yayın durumu kontrol ediliyor": "وضعیت پخش در حال بررسی است",
  "Yayın durumu alınamadı": "دریافت وضعیت پخش ممکن نشد",
  "Tekrar dene": "دوباره تلاش کنید",
  "Canlı yayın oynatıcısı": "پخش‌کننده زنده",
  "Geçmiş Sohbetler": "گفتگوهای گذشته",
  "Yeni Sohbet": "گفتگوی تازه",
  "Sorularınız, cevaplarınız ve kaynakları yalnız kendi hesabınızda saklanır.": "پرسش‌ها، پاسخ‌ها و منابع فقط در حساب شخصی شما نگهداری می‌شوند.",
  "Yükleniyor…": "در حال بارگذاری…",
  "Sohbet geçmişinizi görmek için giriş yapın.": "برای دیدن گفتگوهای گذشته وارد شوید.",
  "Henüz bir sohbetiniz yok.": "هنوز گفتگویی ندارید.",
  "Konuşma": "گفتگو",
  "Siz": "شما",
  "Kaynaklı cevap": "پاسخ مستند",
  "Kaynaklar": "منابع",
  "Soru kaydedildi. Kaynaklı cevap hizmeti henüz hazır değil; bu soruya cevap üretilmedi.": "پرسش ذخیره شد. سرویس پاسخ مستند هنوز آماده نیست؛ پاسخی تولید نشد.",
  "Sorunuz": "پرسش شما",
  "Kaydediliyor…": "در حال ذخیره…",
  "Gönder": "ارسال",
  "Bir soru yazarak yeni sohbet başlatın.": "با نوشتن یک پرسش گفتگوی تازه‌ای آغاز کنید.",
  "Bir sohbet seçin veya yeni sohbet başlatın.": "گفتگویی انتخاب کنید یا گفتگوی تازه‌ای آغاز کنید.",
  "Yalnız gerçekten gönderdiğiniz sorular kaydedilir. Rastgele konu ve katalog araması sohbet oluşturmaz. Bekleyen sorulara otomatik cevap eklenmez.": "فقط پرسش‌های ارسال‌شده ذخیره می‌شوند. موضوع تصادفی و جستجوی فهرست گفتگو ایجاد نمی‌کنند. به پرسش‌های منتظر پاسخ خودکار افزوده نمی‌شود.",
  "Sohbet bilgisi alınamadı veya soru kaydedilemedi. Lütfen yeniden deneyin.": "بارگذاری گفتگو یا ذخیره پرسش ممکن نشد. دوباره تلاش کنید.",
  "Kaydedilen sohbeti aç": "باز کردن گفتگوی ذخیره‌شده",
  "Mesajınız kaydedildi.": "پیام شما ذخیره شد.",
  "Mesajınız kaydedildi": "پیام شما ذخیره شد",
  "Mesaj gönderilemedi. Bilgileriniz korunuyor; tekrar deneyebilirsiniz.": "پیام ارسال نشد. اطلاعات شما حفظ شده است؛ دوباره تلاش کنید.",
  "Dua bağışınız alındı": "اهدای دعای شما دریافت شد",
  "Dua bağışınız kaydedildi.": "اهدای دعای شما ذخیره شد.",
  "Kaydınız hesabınıza eklendi. Allah kabul etsin.": "این رکورد به حساب شما افزوده شد. خداوند قبول کند.",
  "Bağış gönderilemedi. Bilgileriniz korunuyor; tekrar deneyebilirsiniz.": "اهدا ارسال نشد. اطلاعات شما حفظ شده است؛ دوباره تلاش کنید.",
  "Giriş yapılamadı. Bilgilerinizi kontrol edip tekrar deneyin.": "ورود ممکن نشد. اطلاعات خود را بررسی کرده و دوباره تلاش کنید.",
  "Kayıt oluşturulamadı. Bilgilerinizi kontrol edip tekrar deneyin.": "ثبت‌نام ممکن نشد. اطلاعات خود را بررسی کرده و دوباره تلاش کنید.",
  "Hoş geldiniz, {v0}": "خوش آمدید، {v0}",
  "Kaydınız oluşturuldu, hoş geldiniz {v0}": "حساب شما ایجاد شد، خوش آمدید {v0}",
  "Mahmut Efendim’in sohbet kayıtlarına dayalı kaynaklı araştırma asistanı.": "دستیار تحقیق مستند بر پایه گفتگوهای ضبط‌شده محمود افندیم.",
  "Mahmut Efendim AI’ı aç": "باز کردن هوش مصنوعی محمود افندیم",
  "Sorunuzu yazın; cevap ve dayandığı kaynaklar bu konuşmada gösterilecek.": "پرسش خود را بنویسید؛ پاسخ و منابع آن در همین گفتگو نمایش داده می‌شوند.",
  "Yeni soru": "پرسش تازه",
  "Mahmut Efendim AI’a sorun": "از هوش مصنوعی محمود افندیم بپرسید",
  "Kaynaklı cevap hizmeti henüz hazır değil. Sorunuz hesabınıza kaydedilir; doğrulanmış cevap varmış gibi gösterilmez.": "سرویس پاسخ مستند هنوز آماده نیست. پرسش در حساب شما ذخیره می‌شود؛ پاسخ تأییدنشده ارائه نمی‌شود.",
  "Ana Sayfa": "صفحه اصلی",
  "Hakkımızda": "درباره ما",
  "İletişim": "تماس با ما",
  "Menü": "فهرست",
  "Kapat": "بستن",
  "Menüyü aç": "باز کردن فهرست",
  "Menüyü kapat": "بستن فهرست",
  "Ana içeriğe geç": "رفتن به محتوای اصلی",
  "Oturum Aç": "ورود",
  "Giriş Yap": "ورود",
  "Çıkış Yap": "خروج",
  "Hesabım": "حساب من",
  "Hesap": "حساب",
  "Ara": "جستجو",
  "Favoriler": "علاقه‌مندی‌ها",
  "Sepet": "سبد خرید",
  "Hediye": "هدیه",
  "Mağazalar": "فروشگاه‌ها",
  "Bayilik": "نمایندگی",
  "Kategoriler": "دسته‌بندی‌ها",
  "Keşfet": "کاوش",
  "Yeni Sezon": "فصل تازه",
  "Kategori menüsü": "فهرست دسته‌بندی‌ها",
  "Shule ana sayfa": "صفحه اصلی Shule",
  "Dijital Ayak İzleri": "ردپاهای دیجیتال",
  "Kütüphane": "کتابخانه",
  "Dervişin Yolculuğu": "سفر درویش",
  "İlahiler": "سرودهای دینی",
  "Evrad & Zikâr": "اوراد و ذکر",
  "Kasideler": "قصیده‌ها",
  "Konular": "موضوع‌ها",
  "Soru Cevap Arşivi": "آرشیو پرسش و پاسخ",
  "Haftalık Dersler": "درس‌های هفتگی",
  "Canlı Yayın": "پخش زنده",
  "Dua Bağışı": "اهدای دعا",
  "Duyurular": "اطلاعیه‌ها",
  "Kayıtlar": "رکوردها",
  "İrfanla Aydınlanan": "روشن‌شده با عرفان",
  "Bir Yolculuk": "یک سفر",
  "Tüm Kaynaklar": "همه منابع",
  "Sohbetler": "گفتگوها",
  "Sayyâdî'ye bir şey sor…": "از Sayyâdi چیزی بپرسید…",
  "Örnek sorular": "پرسش‌های نمونه",
  "Örnek Sorular": "پرسش‌های نمونه",
  "Rastgele bir konu": "یک موضوع تصادفی",
  "Sadece herkese açık içerikte ara": "فقط در محتوای عمومی جستجو کنید",
  "Öne Çıkan Bölümler": "بخش‌های برجسته",
  "İlim · Sohbet · İrfan": "علم · گفتگو · عرفان",
  "Küçük Detaylar, Büyük Mutluluklar": "جزئیات کوچک، شادی‌های بزرگ",
  "Her Anında": "در هر لحظه",
  "Sen.": "تو.",
  "Tüm Ürünleri Keşfet": "کاوش همه محصولات",
  "Hediye Seç": "انتخاب هدیه",
  "Tarzına göre keşfet": "کاوش بر اساس سبک شما",
  "Tümünü Gör": "نمایش همه",
  "Kolyeler": "گردنبندها",
  "Küpeler": "گوشواره‌ها",
  "Yüzükler": "انگشترها",
  "Bileklikler": "دستبندها",
  "Saç Aksesuarları": "لوازم مو",
  "Halhallar": "خلخال‌ها",
  "Broşlar": "سنجاق‌سینه‌ها",
  "İncele": "بررسی",
  "Dinle": "شنیدن",
  "Oku": "خواندن",
  "Gözat": "مرور",
  "Sohbetlere Git": "رفتن به گفتگوها",
  "Arşive Git": "رفتن به آرشیو",
  "Kütüphaneye Git": "رفتن به کتابخانه",
  "Derslere Git": "رفتن به درس‌ها",
  "Yayın Akışı": "برنامه پخش",
  "Dua Gönder": "ارسال دعا",
  "Zarafeti günlük hayatının bir parçası yap. Shule; takı, saç aksesuarı ve hediye seçkileriyle her anına eşlik eder.": "زیبایی را بخشی از زندگی روزمره کنید. Shule با زیورآلات، لوازم مو و هدیه‌ها همراه شماست.",
  "Geçmişten bugüne uzanan ilim, irfan ve hizmet yolu… Mahmut Efendim'in mirasıyla, Dergâhının bereketiyle…": "راه علم، عرفان و خدمت از گذشته تا امروز… با میراث محمود افندیم و برکت درگاه او…",
  "Sohbet kayıtlarını keşfedin. Kaynaklı cevap hizmeti için doğrulama çalışmaları sürüyor.": "گفتگوهای ضبط‌شده را کاوش کنید. بررسی منابع برای سرویس پاسخ مستند ادامه دارد.",
  "Video, fotoğraf, belge, yazı ve tüm dijital arşivi tek yerde.": "ویدئو، عکس، سند، نوشته و آرشیو دیجیتال در یکجا.",
  "İslâm eserleri kataloğu. Katalog araması ile sayfa ve pasaj incelemesi ayrı aşamalardır.": "فهرست آثار اسلامی. جستجوی فهرست و بررسی صفحه و متن مراحل جداگانه‌اند.",
  "İlahiler, evrad, ezkâr, kasideler, sözlük, kavramlar, rehber içerikler.": "سرودهای دینی، اوراد، اذکار، قصیده‌ها، واژه‌نامه، مفاهیم و راهنماها.",
  "578 eser · 27 makam": "۵۷۸ اثر · ۲۷ مقام",
  "Günlük evradlar, ezkârlar ve hizipler.": "اوراد، اذکار و احزاب روزانه.",
  "Seçme kasideler ve metinleri.": "قصیده‌ها و متن‌های برگزیده.",
  "Akaid, fıkıh, tasavvuf, ahlak, siyer ve daha fazlası.": "عقاید، فقه، تصوف، اخلاق، سیره و بیشتر.",
  "Güncel ve geçmiş haftalık dersler": "درس‌های هفتگی جاری و گذشته",
  "Yayın saatlerini görüntüleyin": "نمایش زمان‌های پخش",
  "Hatim, Salâtü Selâm, Kelime-i Tevhid, Sure ve Tesbihat bağışlayın": "ختم قرآن، صلوات، کلمه توحید، سوره و تسبیحات اهدا کنید",
  "Video arşivi": "آرشیو ویدئو",
  "Soru-cevap": "پرسش و پاسخ",
  "Transkriptler": "متن‌های پیاده‌شده",
  "Video": "ویدئو",
  "Fotoğraf": "عکس",
  "Belgeler": "اسناد",
  "Yazılar": "نوشته‌ها",
  "Eser kataloğu": "فهرست آثار",
  "Kaynak bilgileri": "اطلاعات منابع",
  "Dervişlere özel içeriklere erişmek için oturum açınız.": "برای دسترسی به محتوای ویژه درویشان وارد شوید.",
  "Ders Arşivi": "آرشیو درس‌ها",
  "Kaydettiklerim": "ذخیره‌های من",
  "Kaynak ve Doğrulama Yöntemi": "روش منابع و تأیید",
  "Profilim": "پروفایل من",
  "Asistan": "دستیار",
  "Kaynak arşivleri": "آرشیوهای منابع",
  "Yolculuk ve topluluk": "سفر و جامعه",
  "Kişisel alan": "بخش شخصی",
  "Sohbet Arşivi": "آرشیو گفتگوها",
  "Mahmut Efendim · Sohbet Arşivi": "محمود افندیم · آرشیو گفتگوها",
  "Mahmut Efendim AI": "هوش مصنوعی محمود افندیم",
  "Mahmut Efendim AI · Sohbetler ve Kütüphane": "هوش مصنوعی محمود افندیم · گفتگوها و کتابخانه",
  "Mevcut sohbet ve kitap kayıtlarından bir konu seçin.": "موضوعی از گفتگوها و کتاب‌های موجود انتخاب کنید.",
  "Mevcut kaynaklarda arama": "جستجو در منابع موجود",
  "TEST soru başlıkları, sohbet bilgileri ve kitap künyeleri aranır. Bunlar AI cevabı veya doğrulanmış kitap pasajı değildir.": "عنوان پرسش‌های آزمایشی، اطلاعات گفتگوها و مشخصات کتاب‌ها جستجو می‌شود. این‌ها پاسخ هوش مصنوعی یا متن تأییدشده کتاب نیستند.",
  "Video, fotoğraf, belge ve yazıların kaynak bilgisi korunarak kataloglanacağı alan.": "بخشی برای فهرست‌کردن ویدئو، عکس، سند و نوشته با حفظ اطلاعات منبع.",
  "Eser → baskı/tercüme → cilt → sayfa → bölüm → pasaj hiyerarşisi.": "ساختار اثر ← نسخه/ترجمه ← جلد ← صفحه ← بخش ← متن.",
  "Kaynak içerikleri birbirine bağlayan konu ve etiket dizini.": "نمایه موضوع‌ها و برچسب‌هایی که منابع را به یکدیگر پیوند می‌دهد.",
  "Tarih, konuşmacı, video/ses ve transkript ile haftalık ders kataloğu.": "فهرست درس‌های هفتگی همراه با تاریخ، سخنران، ویدئو/صدا و متن پیاده‌شده.",
  "Mahmut Nedim Aysoy’un Mesnevî dersleri ve eserine ilişkin yayınlar.": "درس‌های مثنوی محمود ندیم آیسوی و مطالب منتشرشده درباره اثر او.",
  "Mevlânâ üzerine yayımlanmış sohbet kaydı.": "گفتگوی منتشرشده درباره مولانا.",
  "İlahi metinleri, makamlar ve müzik çalışmalarının kaynakları.": "متن سرودهای دینی، مقام‌ها و منابع آثار موسیقی.",
  "Sağlanan koleksiyondaki evrad ve kaside metinleri.": "متن اوراد و قصیده‌های مجموعه ارائه‌شده.",
  "Sohbetler ve dersler. Semazen’in Mahmut Nedim Aysoy kaydında bağlantı verdiği YouTube kanalı.": "گفتگوها و درس‌ها؛ کانال یوتیوبی که سمازن در معرفی محمود ندیم آیسوی به آن پیوند داده است.",
  "Mahmut Nedim Aysoy ile yapılan röportajları bir araya getiren podcast serisi.": "مجموعه پادکست مصاحبه‌ها با محمود ندیم آیسوی.",
  "GBB Kültür’ün video koleksiyonunda yayımlanan Dr. Mahmut Nedim Aysoy Mesnevî sohbetleri.": "گفتگوهای مثنوی دکتر محمود ندیم آیسوی در مجموعه ویدئویی GBB Kültür.",
  "Yayınevinin Mahmut Nedim Aysoy adına sunduğu kitap tanıtımı. Eser ve yayın bilgilerine özgün kaynaktan ulaşın.": "معرفی کتاب محمود ندیم آیسوی توسط ناشر. اطلاعات اثر و انتشار را در منبع اصلی ببینید.",
  "Mahmut Nedim Aysoy’un sohbetine ayrılmış sayfa; Sayyâdi TV videosuna yönlendirir.": "صفحه گفتگوی محمود ندیم آیسوی با پیوند به ویدئوی Sayyâdi TV.",
  "Sanatçının Mahmud Nedim Aysoy ile ilişkilendirdiği müzik çalışmalarına ilişkin kendi açıklamaları.": "توضیحات خود هنرمند درباره آثار موسیقی مرتبط با محمود ندیم آیسوی.",
  "3 Eylül 2026 tarihli yazı. Yazarın Mahmut Nedim Aysoy hakkında kaleme aldığı değerlendirme.": "نوشته ۳ سپتامبر ۲۰۲۶؛ ارزیابی نویسنده درباره محمود ندیم آیسوی.",
  "Mahmud adıyla listelenen yayın ve çeviri kayıtları. Yazarlık ve çevirmenlik bilgileri her eserin künyesinde ayrı değerlendirilir.": "آثار و ترجمه‌های فهرست‌شده به نام محمود. اطلاعات نویسنده و مترجم در مشخصات هر اثر جداگانه بررسی می‌شود.",
  "Tasavvuf, tefsir ve irfan geleneğinden eserleri keşfedin. Koleksiyondaki kitapları başlıklarıyla arayın, kaynak bilgilerini inceleyin.": "آثار سنت تصوف، تفسیر و عرفان را کاوش کنید. کتاب‌ها را با عنوان جستجو کرده و اطلاعات منابع را بررسی کنید.",
  "Mahmut Efendim’in sohbetlerini, röportajlarını ve eserlerine ilişkin yayınları özgün kaynaklarından keşfedin. İzleyin, dinleyin, okuyun.": "گفتگوها، مصاحبه‌ها و آثار محمود افندیم را در منابع اصلی کاوش کنید؛ ببینید، بشنوید و بخوانید.",
  "Bir konu seçin; ilgili sohbetleri, yayınları ve metinleri birlikte keşfedin.": "موضوعی انتخاب کنید و گفتگوها، آثار منتشرشده و متن‌های مرتبط را با هم ببینید.",
  "Mesnevî sohbetlerini bölüm bölüm izleyin. Bu bölüm ders kayıtları arşividir; yeni haftanın yayın takvimi henüz ilan edilmemiştir.": "گفتگوهای مثنوی را بخش‌به‌بخش تماشا کنید. این بخش آرشیو درس‌هاست؛ برنامه هفته تازه هنوز اعلام نشده است.",
  "Mahmut Efendim AI için kaynaklı soru-cevap alanı.": "بخش پرسش و پاسخ مستند هوش مصنوعی محمود افندیم.",
  "Sohbet, ders, video ve kaynak kayıtlarının kanıt zincirli kataloğu.": "فهرست گفتگو، درس، ویدئو و منابع با زنجیره شواهد.",
  "Rehber ve kaynak içeriklerinin birleşik keşif alanı.": "بخش کاوش یکپارچه راهنماها و منابع.",
  "İlahi metinleri, makam, icracı, bestekâr/güfte ve ses kayıtları kataloğu.": "فهرست متن سرودهای دینی، مقام، اجراکننده، آهنگساز/شاعر و ضبط‌های صوتی.",
  "Evrad, ezkâr ve hiziplerin metin, kaynak ve isteğe bağlı ses kayıtları.": "متن، منابع و ضبط صوتی اختیاری اوراد، اذکار و احزاب.",
  "Kaside metinleri, müellif, kaynak eser ve ses kayıtları kataloğu.": "فهرست متن قصیده‌ها، نویسنده، اثر منبع و ضبط‌های صوتی.",
  "Soruları doğrulanmış cevap ve kanıt kayıtlarıyla saklayan arşiv.": "آرشیو پرسش‌ها همراه با پاسخ تأییدشده و شواهد.",
  "Canlı yayın adresleri ve yayın programı alanı.": "بخش نشانی پخش زنده و برنامه پخش.",
  "Tarihli ve kaynaklı duyuru kayıtları.": "اطلاعیه‌های تاریخ‌دار و مستند.",
  "Kullanıcının izinli kayıt ve içerik geçmişi.": "تاریخچه رکوردها و محتوای مجاز کاربر.",
  "Kaynaklı AI sohbetlerinin kullanıcı bazlı geçmişi.": "تاریخچه شخصی گفتگوهای مستند هوش مصنوعی.",
  "Sanal Dergâha Hoş Geldiniz": "به درگاه مجازی خوش آمدید",
  "Dua bağışınızı hesabınıza kaydetmek için lütfen giriş yapın.": "برای ذخیره اهدای دعا در حساب خود وارد شوید.",
  "WhatsApp ile giriş henüz kullanılamıyor. E-posta veya Google ile devam edebilirsiniz.": "ورود با واتس‌اپ هنوز فعال نیست. با ایمیل یا گوگل ادامه دهید.",
  "Giriş kodumu WhatsApp üzerinden almayı kabul ediyorum.": "دریافت کد ورود از طریق واتس‌اپ را می‌پذیرم.",
  "Kod isteğiniz kabul edildi. WhatsApp’a gelen kod 5 dakika geçerlidir.": "درخواست کد دریافت شد. کد واتس‌اپ ۵ دقیقه اعتبار دارد.",
  "Telefonla giriş ayrı bir hesap oluşturabilir; mevcut e-posta hesabınızla otomatik birleşmez.": "ورود با تلفن ممکن است حساب جداگانه‌ای ایجاد کند؛ با حساب ایمیل موجود خودکار ادغام نمی‌شود.",
  "Profil bilgisi alınamadı. Lütfen daha sonra tekrar deneyin.": "اطلاعات پروفایل دریافت نشد. بعداً دوباره تلاش کنید.",
  "Özgün kaynak metni Türkçe olarak korunur.": "متن اصلی منبع به زبان ترکی حفظ می‌شود.",
  "Mevcut açık kaynaklarda arama": "جستجو در منابع عمومی موجود",
  "İlahi ve evrad metinleri, kitap katalog başlıkları ve yayımlanmış sohbet bilgileri aranır. Bu sonuçlar yapay zekâ cevabı değildir; özel kitap pasajları ve yerel TEST transkriptleri canlıya henüz bağlı değildir.": "متن سرودها و اوراد، عنوان‌های فهرست کتاب‌ها و اطلاعات گفتگوهای منتشرشده جستجو می‌شود. این نتایج پاسخ هوش مصنوعی نیستند؛ متن کتاب‌های خصوصی و متن‌های آزمایشی محلی هنوز به نسخه زنده متصل نیستند.",
  "Bu sözcüklerle açık koleksiyonda sonuç bulunamadı. Daha kısa bir ifade deneyin.": "با این واژه‌ها نتیجه‌ای در مجموعه عمومی یافت نشد. عبارت کوتاه‌تری امتحان کنید.",
  "Kaydı aç": "باز کردن رکورد",
  "Metin eşleşmesi": "تطابق متن",
  "Katalog başlığı": "عنوان فهرست",
  "Yayın bilgisi": "اطلاعات انتشار",
  "Mevcut TEST videolarındaki soruları kaynak kareleriyle keşfedin.": "پرسش‌های ویدئوهای آزمایشی موجود را همراه با تصویر منبع کاوش کنید.",
  "Bu özel arşiv yalnız yetkili hesapla görüntülenir.": "این آرشیو خصوصی فقط با حساب مجاز قابل مشاهده است.",
  "Arşiv yüklenemedi.": "بارگذاری آرشیو ممکن نشد.",
  "Sorularda ara": "جستجو در پرسش‌ها",
  "Soru veya konu…": "پرسش یا موضوع…",
  "soru": "پرسش",
  "Cevap zaman aralığı henüz doğrulanmadı.": "بازه زمانی پاسخ هنوز تأیید نشده است.",
  "Kitap pasajı henüz bağlanmadı.": "متن کتاب هنوز پیوند داده نشده است.",
  "Videoda birden fazla soru var; cevaplar ayrı ayrı eşlenecek.": "ویدئو چند پرسش دارد؛ پاسخ‌ها جداگانه تطبیق داده می‌شوند.",
  "Transkript dosyası eşlendi; cevap doğrulaması bekleniyor.": "فایل متن پیاده‌شده تطبیق داده شد؛ تأیید پاسخ در انتظار است.",
  "Henüz doğrulanmış cevap yok.": "هنوز پاسخ تأییدشده‌ای وجود ندارد.",
  "Bu aramada soru bulunamadı.": "پرسشی در این جستجو یافت نشد.",
  "Soru başlığı inceleme bekliyor.": "عنوان پرسش در انتظار بررسی است.",
  "Hazır sohbet ve kitap metinlerinden soru veya konu seçin. Yeni metinler yayımlandıkça liste güncellenir.": "از متن‌های آماده گفتگوها و کتاب‌ها پرسش یا موضوعی انتخاب کنید. با انتشار متن‌های تازه، فهرست به‌روز می‌شود.",
  "Bu kapsamda erişiminiz olan hazır bir metin henüz yok.": "در این محدوده هنوز متن آماده‌ای برای دسترسی شما وجود ندارد.",
  "Hazır metinlerden soru ve konu önerisidir; doğrulanmış AI cevabı değildir. Kitap konularında eşleşen PDF sayfaları belirtilir.": "این‌ها پیشنهاد پرسش و موضوع از متن‌های آماده‌اند، نه پاسخ تأییدشده هوش مصنوعی. برای موضوع کتاب، صفحه‌های مرتبط PDF مشخص می‌شود.",
  "Bu tarayıcıda seçtiğiniz içerikler.": "محتوایی که در این مرورگر انتخاب کرده‌اید.",
  "Kayıtlarında ara": "جستجو در ذخیره‌های شما",
  "Henüz kaydedilmiş içerik yok.": "هنوز محتوایی ذخیره نشده است.",
  "İlahilerde yer imi düğmesine basarak listenizi oluşturabilirsiniz.": "با دکمه نشانک سرودهای دینی، فهرست خود را بسازید.",
  "İlahileri keşfet": "کاوش سرودهای دینی",
  "Aramanızla eşleşen kayıt yok.": "رکوردی مطابق جستجو یافت نشد.",
  "Seçimler bu tarayıcıda saklanır; hesabınızla diğer cihazlara eşitlenmez.": "انتخاب‌ها در این مرورگر نگهداری می‌شوند؛ با حساب شما در دستگاه‌های دیگر همگام نمی‌شوند.",
  "Evidence bağlantısı bekleniyor": "در انتظار اتصال شواهد",
  "Sohbet kayıtları kataloglanıyor": "گفتگوها در حال فهرست‌سازی هستند",
  "İçe aktarmaya hazır": "آماده ورود داده",
  "İçerik kabulüne hazır": "آماده دریافت محتوا",
  "Yayın kaynağı bekleniyor": "در انتظار منبع پخش",
  "Kimlik katmanına hazır": "آماده اتصال هویت",
  "AI bağlantısına hazır": "آماده اتصال هوش مصنوعی",
  "Soru": "پرسش",
  "Cevap": "پاسخ",
  "Ses": "صدا",
  "Transkript": "متن پیاده‌شده",
  "Belge": "سند",
  "Yazı": "نوشته",
  "Metin": "متن",
  "Katalog": "فهرست",
  "Tarih": "تاریخ",
  "Başlık": "عنوان",
  "Program": "برنامه",
  "Yayın URL": "نشانی پخش",
  "Kayıt referansı": "ارجاع رکورد",
  "Sohbet kaydı": "گفتگوی ضبط‌شده",
  "Kullanıcı hesabı": "حساب کاربر",
  "Sayyâdi koleksiyonları": "مجموعه‌های Sayyâdi",
  "Dijital arşiv": "آرشیو دیجیتال",
  "İçerik kaynağı": "منبع محتوا",
  "Onaylı yayın akışı": "پخش تأییدشده",
  "Onaylı yayın kaynağı": "منبع پخش تأییدشده",
  "Yayın kaydı": "رکورد پخش",
  "Kullanıcı yetkisi": "مجوز کاربر",
  "İRFANIN İZİNDE · SAYYÂDİ KÜTÜPHANESİ": "در مسیر عرفان · کتابخانه Sayyâdi",
  "MAHMUT NEDİM AYSOY · ÇEVRİMİÇİ KOLEKSİYON": "محمود ندیم آیسوی · مجموعه آنلاین",
  "MAHMUT NEDİM AYSOY · DERS ARŞİVİ": "محمود ندیم آیسوی · آرشیو درس‌ها",
  "Sayyâdi Kaynak Asistanı": "دستیار منابع Sayyâdi",
  "· Video": "· ویدئو",
  "kaynak · Kaynak taraması: 7 Ekim 2026": "منبع · بررسی منابع: ۷ اکتبر ۲۰۲۶",
  "Katalog bağlantısı kurulamadı. Lütfen daha sonra tekrar deneyin.": "اتصال به فهرست ممکن نشد. بعداً دوباره تلاش کنید.",
  "sayfada metin çıkarıldı": "صفحه دارای متن استخراج‌شده",
  "transkript bölümü": "بخش متن پیاده‌شده",
  "Kaynak: ilahiler-site çalışması.zip /": "منبع: ilahiler-site çalışması.zip /",
  "Sayfa yolu": "مسیر صفحه",
  "Kitap rafı": "قفسه کتاب",
  "Sohbet kayıtları": "گفتگوهای ضبط‌شده",
  "Katalog görünümü": "نمایش فهرست",
  "Raf": "قفسه",
  "Liste": "فهرست",
  "Başlıkla ara": "جستجو با عنوان",
  "Bir eser adı yazın…": "نام یک اثر را بنویسید…",
  "Katalog yükleniyor…": "فهرست در حال بارگذاری…",
  "Kaynak kataloğu": "فهرست منابع",
  "SAYYÂDİ KOLEKSİYONU": "مجموعه Sayyâdi",
  "KİTAP KOLEKSİYONU": "مجموعه کتاب‌ها",
  "SOHBET ARŞİVİ": "آرشیو گفتگوها",
  "ESER KAYDI": "رکورد اثر",
  "VİDEO KAYDI": "رکورد ویدئو",
  "Kaynak bilgisi katalogda": "اطلاعات منبع در فهرست",
  "Kayıt bilgilerini incele": "بررسی اطلاعات رکورد",
  "Özgün kayıt adı": "نام اصلی رکورد",
  "Metin hazırlığı": "آماده‌سازی متن",
  "Henüz hazırlanmadı": "هنوز آماده نشده است",
  "Kaynak kimliği": "شناسه منبع",
  "Bu aramada kayıt bulunamadı.": "رکوردی در این جستجو یافت نشد.",
  "Önceki": "قبلی",
  "Sonraki": "بعدی",
  "sayfa": "صفحه",
  "bölüm": "بخش",
  ". sayfa": ". صفحه",
  "İlahi kataloğu": "فهرست سرودهای دینی",
  "İlahi koleksiyonu": "مجموعه سرودهای دینی",
  "Makamını seç, ilahini bul": "مقام را انتخاب کنید، سرود را بیابید",
  "kayıt ·": "رکورد ·",
  "makam ve kategori": "مقام و دسته‌بندی",
  "Seçtiklerim (": "انتخاب‌های من (",
  "İlahi adı veya sözleriyle ara": "جستجو با نام یا متن سرود",
  "Örneğin: sevdim seni…": "برای نمونه: sevdim seni…",
  "Makam / kategori": "مقام / دسته‌بندی",
  "Tüm makamlar (": "همه مقام‌ها (",
  "Makam kısayolları": "میانبر مقام‌ها",
  "sonuç": "نتیجه",
  " · Seçtiklerim": " · انتخاب‌های من",
  "Filtreleri temizle": "پاک کردن فیلترها",
  "Seçilen ilahi": "سرود انتخاب‌شده",
  "Eser bilgilerini kapat": "بستن اطلاعات اثر",
  "Kaynak PDF’yi aç (yeni sekme)": "باز کردن PDF منبع (برگه تازه)",
  "Seçtiklerimden çıkar": "حذف از انتخاب‌های من",
  "Seçtiklerime ekle": "افزودن به انتخاب‌های من",
  "Henüz bir ilahi seçmedin": "هنوز سرودی انتخاب نکرده‌اید",
  "Bu filtrelerle kayıt bulunamadı": "با این فیلترها رکوردی یافت نشد",
  "İlahi sonuç sayfaları": "صفحه‌های نتایج سرودها",
  "Kaside metinleri": "متن قصیده‌ها",
  "Evrad metinleri": "متن اوراد",
  "Başlık veya metin içinde ara": "جستجو در عنوان یا متن",
  "Hatırladığınız sözü yazın…": "عبارتی را که به خاطر دارید بنویسید…",
  "eser · Kullanıcının sağladığı koleksiyondan": "اثر · از مجموعه ارائه‌شده کاربر",
  ". bölüm": ". بخش",
  "Bu aramada eser bulunamadı.": "اثری در این جستجو یافت نشد.",
  "Tümü": "همه",
  "İzle": "تماشا",
  "Kaynaklarda ara": "جستجو در منابع",
  "Dijital kaynak koleksiyonu": "مجموعه منابع دیجیتال",
  "İzleme kaynağını aç": "باز کردن منبع ویدئو",
  "Dinleme kaynağını aç": "باز کردن منبع صوتی",
  "Yayın kaynağını aç": "باز کردن منبع انتشار",
  "(yeni sekme)": "(برگه تازه)",
  "Yayımlayan": "منتشرکننده",
  "Bu aramada kaynak bulunamadı.": "منبعی در این جستجو یافت نشد.",
  "İçeriği aç →": "باز کردن محتوا ←",
  "Kaynağı aç ↗": "باز کردن منبع ↗",
  "Konu seçimi": "انتخاب موضوع",
  "Bu konuda ara": "جستجو در این موضوع",
  "Ders, eser veya bölüm…": "درس، اثر یا بخش…",
  "içerik": "محتوا",
  "Bu konuda aramanıza uygun içerik bulunamadı.": "محتوای مرتبطی با جستجوی شما در این موضوع یافت نشد.",
  "Ders kayıtları": "درس‌های ضبط‌شده",
  "Derslerde ara": "جستجو در درس‌ها",
  "Mesnevî, bölüm, konuşmacı…": "مثنوی، بخش، سخنران…",
  "Sıralama": "مرتب‌سازی",
  "Yayın tarihi bilinenler önce": "تاریخ انتشار مشخص ابتدا",
  "Bölüm numarası": "شماره بخش",
  "yayımlanmış ders kaydı": "درس منتشرشده",
  "Yayın tarihi": "تاریخ انتشار",
  "Kaynakta doğrulanmadı": "در منبع تأیید نشده است",
  "Yayın bilgisini incele ↗": "بررسی اطلاعات انتشار ↗",
  "Bu aramada ders bulunamadı.": "درسی در این جستجو یافت نشد.",
  "Konulara göre keşfet →": "کاوش بر اساس موضوع ←",
  "İlgili Sayyâdi alanları": "بخش‌های مرتبط Sayyâdi",
  "Koleksiyonu keşfet": "کاوش مجموعه",
  "Koleksiyon ve kaynak bilgisi": "اطلاعات مجموعه و منابع",
  "Dervişin Yolculuğu koleksiyonları": "مجموعه‌های سفر درویش",
  "Bu bölüm hazırlanıyor": "این بخش در حال آماده‌سازی است",
  "Ana Sayfaya Dön": "بازگشت به صفحه اصلی",
  "Ad Soyad": "نام و نام خانوادگی",
  "E-posta": "ایمیل",
  "Mesajınız": "پیام شما",
  "Mesajınız…": "پیام شما…",
  "Soru, görüş ve taleplerinizi bize iletebilirsiniz.": "پرسش‌ها، دیدگاه‌ها و درخواست‌های خود را برای ما بفرستید.",
  "Bağış Türü": "نوع اهدا",
  "Adet": "تعداد",
  "Adedi 10 azalt": "کاهش تعداد به میزان ۱۰",
  "Adedi 10 artır": "افزایش تعداد به میزان ۱۰",
  "Not (isteğe bağlı)": "یادداشت (اختیاری)",
  "Niyetinizi veya bir notu yazabilirsiniz…": "نیت یا یادداشتی بنویسید…",
  "Google ile devam et": "ادامه با گوگل",
  "veya e-posta ile": "یا با ایمیل",
  "Kayıt Ol": "ثبت‌نام",
  "Şifre": "رمز عبور",
  "Şifre (en az 6 karakter)": "رمز عبور (حداقل ۶ نویسه)",
  "WhatsApp ile telefon girişi": "ورود تلفنی با واتس‌اپ",
  "WhatsApp ile giriş": "ورود با واتس‌اپ",
  "Kullanılabilirlik kontrol ediliyor…": "در حال بررسی دسترسی…",
  "Cep telefonu": "تلفن همراه",
  "6 haneli giriş kodu": "کد ورود ۶ رقمی",
  "Numarayı değiştir / yeni kod iste": "تغییر شماره / درخواست کد تازه",
  "İşleniyor…": "در حال پردازش…",
  "Kodu doğrula ve giriş yap": "تأیید کد و ورود",
  "WhatsApp kodu iste": "درخواست کد واتس‌اپ",
  "KİŞİSEL ALAN": "بخش شخصی",
  "Profil ve oturum bilgileriniz": "اطلاعات پروفایل و نشست شما",
  "Profil yükleniyor…": "پروفایل در حال بارگذاری…",
  "Manevî statü": "جایگاه معنوی",
  "Hizmet / vazife": "خدمت / وظیفه",
  "Profil unvanı": "عنوان پروفایل",
  "Henüz kayıtlı bilgi yok": "هنوز اطلاعاتی ثبت نشده است",
  "Araştırma alanına geç →": "رفتن به بخش تحقیق ←",
  "Hukuki bilgiler": "اطلاعات حقوقی",
  "Gizlilik Politikası": "سیاست حریم خصوصی",
  "Veri Silme": "حذف داده‌ها",
  "Kullanım Koşulları": "شرایط استفاده",
  "Kaynak": "منبع",
  "Veri türleri": "نوع داده‌ها",
  "Kanıt kuralı": "قاعده شواهد",
  "Kaynak ve kanıt odaklı": "با تمرکز بر منبع و شواهد",
  "Kaynak asistanını kapat": "بستن دستیار منابع",
  "Kaynak alanını aç": "باز کردن بخش منابع",
  "Kaynak arama sorusu": "پرسش جستجوی منبع",
  "Sorunu yaz…": "پرسش خود را بنویسید…",
  "Kaynak ara": "جستجوی منبع",
  "Bir kitapla başlayan": "آغاز با یک کتاب",
  "yolculuk.": "یک سفر.",
  "Bir sesin, bir sözün": "در پی یک صدا، یک سخن",
  "izinde.": "در مسیر.",
  "Koleksiyona göz at ↓": "دیدن مجموعه ↓",
  "Dijital izleri keşfet ↓": "کاوش ردپاهای دیجیتال ↓",
  "KONUDAN KAYNAĞA": "از موضوع به منبع",
  "Mesnevî ve Sohbetler": "مثنوی و گفتگوها",
  "İlahiler ve Dinî Mûsiki": "سرودها و موسیقی دینی",
  "Evrad, Zikir ve Kasideler": "اوراد، ذکر و قصیده‌ها",
  "Video ders": "درس ویدئویی",
  "Kitap tanıtımı": "معرفی کتاب",
  "Video koleksiyonu": "مجموعه ویدئو",
  "Video sohbet": "گفتگوی ویدئویی",
  "Metin koleksiyonu": "مجموعه متن",
  "Müzik yayını": "انتشار موسیقی",
  "Kaside": "قصیده",
  "Evrad": "اوراد",
  "{v0} {v1} · Doğrulama bekliyor": "{v0} {v1} · در انتظار تأیید",
  "Güncel katalog · Bu görünümde {v0} kayıt": "فهرست جاری · {v0} رکورد در این نمایش",
  "Son kayıtlı katalog · {v0}. Güncel bağlantı kurulamadı.": "آخرین فهرست ذخیره‌شده · {v0}. اتصال جاری ممکن نشد.",
  "Katalog kaydı, metnin doğrulanmış olduğu anlamına gelmez. Kaynak, sayfa veya zaman bilgisi ve metin doğruluğu birlikte kontrol edilir.": "وجود رکورد در فهرست به معنی تأیید متن نیست. منبع، صفحه یا زمان و درستی متن با هم بررسی می‌شوند.",
  "Bu katalog kaydı tam metin erişimi veya metin doğruluğu onayı değildir. Raf görseli temsili tasarımdır; özgün kitap kapağı değildir.": "این رکورد فهرست، دسترسی به متن کامل یا تأیید درستی متن نیست. تصویر قفسه نمایشی است و جلد اصلی کتاب نیست.",
  "Kaynak: ilahiler-site çalışması.zip / ilahiler.html. Metin, sağlanan kaynaktan aktarılmıştır; ses kaydı bu kayda bağlı değildir.": "منبع: ilahiler-site çalışması.zip / ilahiler.html. متن از منبع ارائه‌شده منتقل شده است؛ ضبط صوتی به این رکورد متصل نیست.",
  "Kayıtlardaki yer imi düğmesiyle kendi listeni oluşturabilirsin.": "با دکمه نشانک رکوردها فهرست خود را بسازید.",
  "Başlığı kısaltabilir veya makam filtresini temizleyebilirsin.": "عنوان را کوتاه‌تر کنید یا فیلتر مقام را پاک کنید.",
  "Seçtiklerim bu tarayıcıda saklanır. Arama ve makam bağlantısını adres çubuğundan paylaşabilirsin.": "انتخاب‌ها در این مرورگر ذخیره می‌شوند. می‌توانید پیوند جستجو و مقام را از نوار نشانی به اشتراک بگذارید.",
  "Metinler sağlanan kaynakta yer aldığı biçimde sunulur. Ayrı bir ilmî metin doğrulaması yapıldığı veya ses kaydı bulunduğu iddia edilmez.": "متن‌ها به شکل موجود در منبع ارائه می‌شوند. تأیید علمی جداگانه متن یا وجود ضبط صوتی ادعا نمی‌شود.",
  "Bu koleksiyon araştırmayla genişletilir; internetteki tüm kayıtları kapsadığı iddia edilmez. Yayımlayan bilgisi hesap sahipliği iddiası değildir. Dış kaynakların içerikleri ve kullanım hakları ilgili yayımlayanlara aittir; bağlantılar özgün sayfalara açılır.": "این مجموعه با تحقیق گسترش می‌یابد و شامل همه رکوردهای اینترنت نیست. اطلاعات منتشرکننده به معنی مالکیت حساب نیست. محتوا و حقوق منابع خارجی متعلق به منتشرکنندگان است؛ پیوندها صفحه اصلی منبع را باز می‌کنند.",
  "Bu dizin yayımlanmış içerikleri bir araya getirir. Özel arşiv ve henüz yayına hazırlanmamış kayıtlar bu listede yer almaz.": "این نمایه مطالب منتشرشده را گردآوری می‌کند. آرشیو خصوصی و رکوردهای آماده‌نشده برای انتشار در این فهرست نیستند.",
  "Yayın tarihi dersin yapıldığı tarih değildir. Burada yalnız açık kaynaklarda doğrulanan kayıtlar listelenir; tüm yerel arşivi kapsamaz. Bu kayıtların transkriptleri henüz buraya bağlanmamıştır.": "تاریخ انتشار، تاریخ برگزاری درس نیست. فقط رکوردهای تأییدشده منابع عمومی فهرست شده‌اند؛ همه آرشیو محلی را شامل نمی‌شود. متن پیاده‌شده این رکوردها هنوز به اینجا متصل نیست.",
  "Manevî statü ve profil unvanı teknik yönetim veya özel içerik izni sağlamaz. Statü ve vazife atama süreci kesinleştirilene kadar bu alanlar buradan değiştirilemez.": "جایگاه معنوی و عنوان پروفایل مجوز مدیریت فنی یا محتوای خصوصی نمی‌دهند. تا تعیین روند انتصاب، این بخش‌ها از اینجا تغییر نمی‌کنند.",
  "” sayfası yakında burada olacak. Sayyâdî Dergâhı'nın dijital hazinesi, kaynaklı ve kanıtlı içeriklerle siz dervişlere açılıyor.": "» به‌زودی در اینجا آماده می‌شود. گنجینه دیجیتال درگاه Sayyâdi با محتوای مستند برای درویشان گشوده می‌شود.",
  "Hatim, Salâtü Selâm, Kelime-i Tevhid, Sure ve Tesbihat bağışlayın.": "ختم قرآن، صلوات، کلمه توحید، سوره و تسبیحات اهدا کنید.",
  "Sohbetleri videoların soru kareleri ve konu başlıklarıyla keşfedin.": "گفتگوها را با تصویر پرسش و عنوان موضوع ویدئوها کاوش کنید.",
  "Özel sohbet arşivi · TEST": "آرشیو خصوصی گفتگوها · آزمایشی",
  "Açık yayımlanmış dersler": "درس‌های منتشرشده عمومی",
  "Özel sohbet kareleri yalnız yetkili hesapla görüntülenir.": "تصاویر گفتگوهای خصوصی فقط با حساب مجاز دیده می‌شوند.",
  "Özel arşiv bağlantısı kurulamadı. Açık dersler aşağıda gösteriliyor.": "اتصال به آرشیو خصوصی ممکن نشد. درس‌های عمومی در زیر نمایش داده می‌شوند.",
  "Soru, konu veya konuşmacı…": "پرسش، موضوع یا سخنران…",
  "video": "ویدئو",
  "Videonun soru karesi": "تصویر پرسش ویدئو",
  "Video karesi yüklenemedi": "تصویر ویدئو بارگذاری نشد",
  "Videodaki sorular": "پرسش‌های این ویدئو",
  "Soru kareleri mevcut videolardan alınmıştır. Bu görünüm soru başlıklarını gösterir; cevap zamanları ve kitaplarla karşılaştırma henüz bağlanmamıştır.": "تصویر پرسش از ویدئوهای موجود گرفته شده است. این نمایش عنوان پرسش‌ها را نشان می‌دهد؛ زمان پاسخ و مقایسه کتاب‌ها هنوز پیوند داده نشده‌اند.",
  "Videoyu izle": "تماشای ویدئو",
  "Kartlar": "کارت‌ها",
  "Mesnevî sohbetlerinin ders arşivi. Seriyi seçin ve birinci bölümden başlayarak izleyin.": "آرشیو درس‌های گفتگوهای مثنوی. مجموعه را انتخاب کرده و از بخش نخست تماشا کنید.",
  "Tüm seriler": "همه مجموعه‌ها",
  "Önceki bölümler": "بخش‌های قبلی",
  "2. dönem": "دوره دوم",
  "Bu serinin dönem numarası kaynak başlıklarında belirtilmiyor.": "شماره دوره این مجموعه در عنوان‌های منبع ذکر نشده است.",
  "Bölüm, konuşmacı veya yayıncı…": "بخش، سخنران یا منتشرکننده…",
  "Bölüm sırası": "ترتیب بخش‌ها",
  "ders kaydı": "رکورد درس",
  "Seri seçimi": "انتخاب مجموعه",
  "İlk bölümü izle": "تماشای بخش نخست",
  "İzleme kaynakları": "منابع تماشا",
  "Bulunan açık kaynak kayıtları listelenir; serilerin sona erdiği veya tüm arşivin tamamlandığı anlamına gelmez. Aynı bölümün farklı yayınları tek kartta gösterilir. Kaynakların transkriptleri henüz bu sayfaya bağlı değildir.": "رکوردهای عمومی یافت‌شده فهرست می‌شوند؛ این به معنی پایان مجموعه یا کامل‌بودن آرشیو نیست. انتشارهای مختلف یک بخش در یک کارت نشان داده می‌شوند. متن‌های پیاده‌شده هنوز به این صفحه متصل نیستند.",
  "Üyelik başvurunuz alındı, {v0}. Yönetici onayı bekleniyor.": "درخواست عضویت شما دریافت شد، {v0}. در انتظار تأیید مدیر است.",
  "Sayyâdi kapalı bir platformdur. Üyelik başvurunuz yönetici tarafından onaylandıktan sonra, size verilen yetkilerle giriş yapabilirsiniz.": "Sayyâdi یک پلتفرم خصوصی است. پس از تأیید درخواست عضویت توسط مدیر، با مجوزهای تعیین‌شده وارد می‌شوید.",
  "Üyelik Başvurusu": "درخواست عضویت",
  "Oturum kontrol ediliyor…": "نشست در حال بررسی است…",
  "Üyelik izni kontrol ediliyor…": "مجوز عضویت در حال بررسی است…",
  "Üyelik kontrolü yapılamadı": "بررسی عضویت ممکن نشد",
  "Başvurunuz onaylanmadı": "درخواست شما تأیید نشد",
  "Başvurunuz onay bekliyor": "درخواست شما در انتظار تأیید است",
  "Bağlantı kurulmadan içerik açılamaz. Lütfen yeniden deneyin.": "بدون اتصال، محتوا نمایش داده نمی‌شود. دوباره تلاش کنید.",
  "Yönetici onayından sonra size tanımlanan içeriklere erişebilirsiniz.": "پس از تأیید مدیر، به محتوای مجاز خود دسترسی خواهید داشت.",
  "Çıkış yap": "خروج",
  "Bu bölüm için yetkiniz yok": "برای این بخش مجوز ندارید",
  "Erişim düzeyinizi yönetici belirler.": "مدیر سطح دسترسی شما را تعیین می‌کند.",
  "Ana sayfaya dön": "بازگشت به صفحه اصلی",
  "Üyelik ve erişim yönetimi": "مدیریت عضویت و دسترسی",
  "Müellif": "نویسنده",
  "Doğrulama bekliyor": "در انتظار تأیید"
};
export function persianCopy(value) {
 if(typeof value==='string')return persianTranslations[value]||value;
 if(Array.isArray(value))return value.map(persianCopy);
 if(value&&typeof value==='object')return Object.fromEntries(Object.entries(value).map(([key,text])=>[key,persianCopy(text)]));
 return value;
}
